module.exports = __webpack_public_path__ + "assets/macbookPreview-2x.89b4457005f0dca1ecd6c601bdefcfa6361d0c2982f3bfcc9ec946beb7906d7a.png";